/**
 * Reports Dashboard Page
 */
import React from 'react';

const ReportsDashboard = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Reports Dashboard</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Generate and view SACCOS reports</p>
    </div>
  );
};

export default ReportsDashboard;
